import { PremiumPrice } from 'src/api/internal/schema';

export type PlanOffer = {
  savePercent: number | null;
  /** Pre-discount amount in the same unit as the paywall's displayed price. */
  comparisonAmount: number | null;
  /** Pre-discount total for the billing period. */
  comparisonTotal: number | null;
};

const percentOff = (full: number, final: number) => {
  if (full <= 0) return 0;
  return Math.round(((full - final) / full) * 100);
};

/**
 * Matches the condensed plans cards: a real price cut wins, otherwise a yearly
 * plan is compared with twelve months at the monthly price.
 */
export const getPlanOffer = (price: PremiumPrice, monthlyFinalPrice?: number): PlanOffer => {
  const { fullPrice, finalPrice, paymentPeriod, discount } = price;
  const isYear = paymentPeriod === 'year';

  let comparisonTotal: number | null = null;
  if (fullPrice > finalPrice) {
    comparisonTotal = fullPrice;
  } else if (isYear && monthlyFinalPrice != null) {
    const yearlyFromMonthly = monthlyFinalPrice * 12;
    if (yearlyFromMonthly > finalPrice) comparisonTotal = yearlyFromMonthly;
  }

  const saveFromPrices = comparisonTotal == null ? null : percentOff(comparisonTotal, finalPrice);
  const savePercent =
    saveFromPrices != null && saveFromPrices > 0
      ? saveFromPrices
      : discount && discount.percent > 0
        ? discount.percent
        : null;

  if (savePercent == null || comparisonTotal == null) {
    return { savePercent, comparisonAmount: null, comparisonTotal: null };
  }

  return {
    savePercent,
    comparisonTotal,
    comparisonAmount: isYear ? comparisonTotal / 12 : comparisonTotal,
  };
};
